import { useSelector } from "react-redux";
import AdminStats from "./AdminStats";
import SummaryCards from "./SummaryCards";
import EnabledAgents from "./EnabledAgents";
import RegionBreakDown from "./RegionBreakdown";
import RegisteredAgents from "./RegsiteredAgents";
import AgentToAggregatorRatio from "./AgentToAggregatorRatio";
import AgentsRegistrationStatus from "./AgentsRegistrationStatus";
import DashboardOnboardingHeader from "../../common/OnboardingHeader";

import { hasPermission } from "utils/helper";
import { permissions } from "utils/permissions";

const OnboardingStatistics = () => {
  const {
    user: { user },
    onboarding: { userType },
  } = useSelector((state) => ({
    user: state.user,
    onboarding: state.onboardingReducer,
  }));

  return (
    <>
      <div className="dashboard-page-container">
        <DashboardOnboardingHeader />
        <SummaryCards />

        <div className="row">
          {hasPermission(permissions.canSeeUserManagement, user.authorities) &&
            userType !== "ADMIN" && (
              <>
                <div className="col-md-6">
                  <RegisteredAgents />
                </div>
                <div className="col-md-6">
                  <EnabledAgents />
                </div>
                <div className="col-md-6" style={{ margin: "4rem 0" }}>
                  <AgentsRegistrationStatus />
                </div>
                <div className="col-md-6" style={{ margin: "4rem 0" }}>
                  <AgentToAggregatorRatio />
                </div>
                <div className="col-md-6">
                  <RegionBreakDown />
                </div>
              </>
            )}

          {hasPermission(
            permissions.canSeeUserManagementAdmin,
            user.authorities
          ) &&
            userType === "ADMIN" && (
              <div className="col-md-7 mt-4">
                <AdminStats />
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default OnboardingStatistics;
